import { TabId } from './TabId';
import type { TabType } from './TabsMenu';

export const navTabs = (): TabType[] => [
    {
        id: TabId.WhatYouGet,
        label: __('What you get'),
    },
    {
        id: TabId.HowItWorks,
        label: __('How it works'),
    },
    {
        id: TabId.ProductComparison,
        label: __('Pricing'),
    },
    {
        id: TabId.Faq,
        label: __('FAQs'),
    },
];
